module.exports = __webpack_public_path__ + "images/category_lp/alcohol/assessment_achievements/1_35e275325e7286ebbadef1cb5e2770f9.jpg";